import { authClient, baseClient, getServiceURL } from '@/utils'
import { ApiCaller } from '@front/utils'
import Toggles from '@domain/toggles/Toggles';
import TogglesV2 from '@domain/toggles/TogglesManager';
import { getServiceURLserverSide } from '@domain/infrastructure/Urls'

const designerDetails = (subfamilyId) => baseClient.get(`${getServiceURL('apiv2')}/subfamily/${subfamilyId}/designer`)

const fetchCollections = ({ catalogId, lang, subFamilyId, withImages = true, rolId, isAuthenticated, userEmail }) => {
	const includeHidden = TogglesV2.isEnabledForEmail('bypassHiddenCollectionsFilter', userEmail)
	const includeHiddenParam = includeHidden ? '&includeHidden=true' : ''

	if (Toggles.isEnabled('collectionsFromWebApi')) {
		let url = `${getServiceURLserverSide('v3')}/collections/${catalogId}/order?lang=${lang}`
		if (subFamilyId) url += `&subFamilyId=${subFamilyId}`
		url += includeHiddenParam
		if (isAuthenticated) return authClient.get(url)
		return baseClient.get(url)
	}
	if (Toggles.isEnabled('productsArticlesWithRedis')) {
		let url = `products/articles/collections?catalogId=${catalogId}&lang=${lang}&images=${withImages ? 1 : undefined}&subFamilyId=${subFamilyId}`
		if (Toggles.isEnabled('productsArticlesWithRoleId') && rolId) url += `&role=${rolId}`
		url += includeHiddenParam

		return ApiCaller.call('v2', 'GET', url)
	} else {
		return authClient.get(`${getServiceURL('products')}/v1/articles/collections`, {
			params: {
				catalogId,
				lang,
				subFamilyId,
				images: withImages ? 1 : undefined,
				...(includeHidden ? { includeHidden: true } : {})
			}
		})
	}
}

export default {
	designerDetails,
	fetchCollections
}
